import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import {validationHandlers} from '../../../../helpers/quiz'

const useStyles = makeStyles(questionValidationsStyles)

export default function QuestionValidations ({question, type, context}) {

  const classes = useStyles()

  const {translate} = context

  const validations = validationHandlers[type.name] || []

  return (
    <Box className={classes.root}>
      {validations.filter(([validate]) => !validate(question)).map(([_, message], index) => {
        const simple = typeof(message) == 'string'
        return (<React.Fragment key={index}>
          {simple && <Box className={classes.validation}>{translate(message, question)}</Box>}
          {!simple && message(question, context).map((message, index) => (
            <Box key={index} className={classes.validation}>
              {message}
            </Box>
          ))}
        </React.Fragment>)
      })}
    </Box>
  )
}

function questionValidationsStyles (theme) {
  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column'
    },
    validation: {
      marginTop: 5,
      color: 'red',
      fontSize: '10pt',
      "&:last-child": {
        marginBottom: 20
      }
    }
  }
}
